const firstIndexSecEl = document.querySelector('.first-home-container,.first-sec.contact-page');

if (firstIndexSecEl) {
  /*const firstSecHeight = firstIndexSecEl.offsetHeight;
  firstGradientBgEl.style.setProperty(
    '--first-sec-height',
    `${firstSecHeight}px`
  );*/

  import('./gradient.component.js').then(({ Gradient }) => {
    const gradient = new Gradient();
    gradient.initGradient('#gradient-canvas');
  });
}